/**
 * Generates event when user makes new movement (like a swipe on a touchscreen).
 * @version 1.1.4
 * @link https://github.com/Promo/wheel-indicator
 * @license MIT
 */

/* global module, window, document */

var WheelIndicator;
(function(){
    WheelIndicator = (function(win, doc) {
        var eventWheel = 'onwheel' in doc || $$.browser.name == 'ie' ? 'wheel' : 'mousewheel',

            DEFAULTS = {
                callback: function(){},
                elem: doc,
                preventMouse: false
            };

        function Module(options){
            this._options = extend(DEFAULTS, options);
            this._deltaArray = [ 0, 0, 0 ];
            this._isAcceleration = false;
            this._isStopped = true;
            this._direction = '';
            this._timer = '';
            this._isWorking = true;

            var self = this;
            this._wheelHandler = function(event) {
                if (self._isWorking) {
                    processDelta.call(self, event);

                    if (self._options.preventMouse) {
                      preventDefault(event);
                    }
                }
            };

            addEvent(this._options.elem, eventWheel, this._wheelHandler);
        }

        Module.prototype = {
            constructor: Module,

            turnOn: function(callback){
                this._isWorking = true;

                if ( callback ) {
                    this._options.callback.call(this, event);
                }

                return this;
            },

            turnOff: function(){
                this._isWorking = false;

                return this;
            },

            setOptions: function(options){
                this._options = extend(this._options, options);

                return this;
            },

            getOption: function(option){
                var neededOption = this._options[option];

                if (neededOption !== undefined) {
                  return neededOption;
                }

                throw new Error('Unknown option');
            },

            destroy: function(){
                removeEvent(this._options.elem, eventWheel, this._wheelHandler);

                return this;
            }
        };

        function triggerEvent(event){
            event.direction = this._direction;

            this._options.callback.call(this, event);
        }

        var getDeltaY = function(event){

            if(event.wheelDelta && !event.deltaY) {
                getDeltaY = function(event) {
                    return event.wheelDelta * -1;
                };
            } else {
                getDeltaY = function(event) {
                    return event.deltaY;
                };
            }

            return getDeltaY(event);
        };

        function preventDefault(event){
            event = event || win.event;

            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }
        }

        function processDelta(event) {
            var
                self = this,
                delta = getDeltaY(event);

            if (delta === 0) return;

            var direction = delta > 0 ? 'down' : 'up',
                arrayLength = self._deltaArray.length,
                changedDirection = false,
                repeatDirection = 0,
                sustainableDirection, i;

            clearTimeout(self._timer);

            self._timer = setTimeout(function() {
                self._deltaArray = [ 0, 0, 0 ];
                self._isStopped = true;
                self._direction = direction;
            }, 150);

            //check how many of last three deltas correspond to certain direction
            for(i = 0; i < arrayLength; i++) {
                if(self._deltaArray[i] !== 0) {
                    self._deltaArray[i] > 0 ? ++repeatDirection : --repeatDirection;
                }
            }

            //if all of last three deltas is greater than 0 or lesser than 0 then direction is switched
            if(Math.abs(repeatDirection) === arrayLength) {
                //determine type of sustainable direction
                //(three positive or negative deltas in a row)
                sustainableDirection = repeatDirection > 0 ? 'down' : 'up';

                if(sustainableDirection !== self._direction) {
                    //direction is switched
                    changedDirection = true;
                    self._direction = direction;
                }
            }

            //if wheel`s moving and current event is not the first in array
            if(!self._isStopped){
                if(changedDirection) {
                    self._isAcceleration = true;

                    triggerEvent.call(this, event);
                } else {
                    //check only if movement direction is sustainable
                    if(Math.abs(repeatDirection) === arrayLength) {
                        //must take deltas to don`t get a bug
                        //[-116, -109, -103]
                        //[-109, -103, 1] - new impulse

                        analyzeArray.call(this, event);
                    }
                }
            }

            //if wheel is stopped and current delta value is the first in array
            if(self._isStopped) {
                self._isStopped = false;
                self._isAcceleration = true;
                self._direction = direction;

                triggerEvent.call(this, event);
            }

            self._deltaArray.shift();
            self._deltaArray.push(delta);
        }

        function analyzeArray(event) {
            var
                deltaArray0Abs  = Math.abs(this._deltaArray[0]),
                deltaArray1Abs  = Math.abs(this._deltaArray[1]),
                deltaArray2Abs  = Math.abs(this._deltaArray[2]),
                deltaAbs        = Math.abs(getDeltaY(event));

            if((deltaAbs       > deltaArray2Abs) &&
                (deltaArray2Abs > deltaArray1Abs) &&
                (deltaArray1Abs > deltaArray0Abs)) {

                if(!this._isAcceleration) {
                    triggerEvent.call(this, event);
                    this._isAcceleration = true;
                }
            }

            if((deltaAbs < deltaArray2Abs) &&
                (deltaArray2Abs <= deltaArray1Abs)) {
                this._isAcceleration = false;
            }
        }

        function addEvent(elem, type, handler){
            if(elem.addEventListener) {
                elem.addEventListener(type, handler, false);
            } else if (elem.attachEvent) {
                elem.attachEvent('on' + type, handler);
            }
        }

        function removeEvent(elem, type, handler) {
            if (elem.removeEventListener) {
                elem.removeEventListener(type, handler, false);
            } else if (elem.detachEvent) {
                elem.detachEvent('on'+ type, handler);
            }
        }

        function extend(defaults, options) {
            var extended = {},
                prop;

            for (prop in defaults) {
                if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
                    extended[prop] = defaults[prop];
                }
            }

            for (prop in options) {
                if (Object.prototype.hasOwnProperty.call(options, prop)) {
                    extended[prop] = options[prop];
                }
            }

            return extended;
        }

        return Module;
    }(window, document));

    if (typeof exports === 'object') {
        module.exports = WheelIndicator;
    }
})();


(function($){
    var $HB = $('html, body');
    var $window = $(window);

    $.fn.billboard = function () {

        return $(this).each(function (billboard_i, billboard) {
            var Wheel;
            var methods = [];

            var $billboard = $(billboard);
            var $billboard_items = $billboard.find('[js-billboard-item]');
            var $billboard_bg = $billboard.find('[js-billboard-bg]');
            var $billboard_nav = $billboard.find('[js-billboard-nav]');
            var $billboard_nav_bar = $billboard_nav.find('.billboard__nav-bar');
            var $billboard_nav_number = $billboard_nav_bar.find('.billboard__nav-bar-number');

            var states = {
                page_loaded: false,
                position: 'first',
                phisical: 'outside',
                direction: 0,
                locked: false,
                index_was: 0,
                index_current: 0,
                items_length: $billboard_items.length
            }

            var boundaries = {
                magnit: 200,
                start: 0,
                end: 0,
                header_height: 0,
                window_scrollTop: 0,
                window_height: 0,
                billboard_top: 0,
                billboard_height: 0
            };

            methods.init = function () {
                // methods.setSlide(0, true);
                methods.getBoundaries();
                methods.bindScrolls();

                $billboard.on({
                    'setSlide.bill': function (e, index) {
                        index && methods.setSlide(index);
                    }
                });

                $billboard_nav_bar.css({
                    height: 100/states.items_length +'%'
                });
            };

            methods.setSlide = function (index, force) {
                if ( states.locked || ( index == states.index_current && !force) ) return;
                states.phisical = 'inside';
                states.locked = true;
                if ( boundaries.window_scrollTop != boundaries.start ) {
                    $HB.not(':animated').animate({
                        scrollTop: boundaries.start
                    }, 500);
                }

                states.index_was = states.index_current;
                states.index_current = index == 'next' ? states.index_current+1 : index == 'prev' ? states.index_current-1 : index;
                states.index_current = states.index_current <= 0 ? 0 : states.index_current >= states.items_length-1 ? states.items_length-1 : states.index_current;
                states.position = states.index_current == 0 ? 'first' : states.index_current == states.items_length-1 ? 'last' : states.index_current;

                if ( states.index_was > states.index_current ) {
                    $billboard.addClass('direction-prev').outerHeight();
                }
                else {
                    $billboard.removeClass('direction-prev').outerHeight();
                }


                $billboard_items.eq(states.index_was).removeClass('is-active').addClass('is-leaving').one({
                    'transitionend webkitTransitionEnd oTransitionEnd': function (e) {
                        $billboard_items.eq(states.index_was).removeClass('is-leaving');
                    }
                });

                $billboard_bg.css({
                    backgroundColor: $billboard_items.eq(states.index_current).find('.billboard-slide__bg').css('backgroundColor')
                });
                $billboard_items.eq(states.index_current).removeClass('is-leaving').addClass('is-active');
                $billboard_nav_bar.css({
                    top: ((states.index_current*100)/states.items_length) +'%'
                });
                $billboard_nav_number.text( ('0'+ (states.index_current+1)).slice(-2) );

                setTimeout(function(){
                    states.locked = false;
                    Wheel.setOptions({preventMouse: false});
                }, 1000);

            };

            methods.getBoundaries = function () {
                var _boundaries = {
                    window_scrollTop: boundaries.window_scrollTop = $window.scrollTop(),
                    window_height: boundaries.window_height = $window.height(),
                    billboard_top: boundaries.billboard_top = Math.round($billboard.offset().top),
                    billboard_height: boundaries.billboard_height = Math.round($billboard.outerHeight(true)),
                    header_height: $('[js-header-top]').outerHeight()
                };
                _boundaries.start = boundaries.start = _boundaries.billboard_top - _boundaries.header_height;
                _boundaries.end = boundaries.end = Math.round(_boundaries.start + _boundaries.billboard_height - _boundaries.header_height);
                return _boundaries;
            };

            Wheel = new WheelIndicator({
                elem: $billboard[0],
                callback: function(e){
                    states.direction = e.direction == 'up' ? -1 : 1;

                    if ( states.phisical == 'inside' ) {
                        $window.on('mousewheel.billboard-disable-wheel', function(e) {
                            e.preventDefault()
                            if ( !(boundaries.window_scrollTop + boundaries.magnit >= boundaries.start && boundaries.window_scrollTop <= boundaries.end - boundaries.window_height + boundaries.magnit) ) {
                                $window.off('.billboard-disable-wheel');
                                states.phisical = 'outside';
                            }
                        });
                        if ( states.locked ) return;
                        if ( (states.position == 'first' && states.direction < 0) || (states.position == 'last' && states.direction > 0) ) {
                            states.phisical = 'outside';
                            $window.off('.billboard-disable-wheel');
                            return;
                        }
                        if ( states.direction > 0 ) {
                            methods.setSlide('next');
                        }
                        else if ( states.direction < 0 ) {
                            methods.setSlide('prev');
                        }
                    }
                }
            });

            var resizeTimer;
            methods.bindScrolls = function () {
                $window.off('.billboard-scroll').off('.billboard-init').on({
                    'scroll.billboard-scroll': function (e) {
                        boundaries.window_scrollTop = $window.scrollTop();

                        if ( states.phisical == 'outside' && !((states.position == 'first' && states.direction < 0) || (states.position == 'last' && states.direction > 0)) && (boundaries.window_scrollTop + boundaries.magnit >= boundaries.start && boundaries.window_scrollTop <= boundaries.end - boundaries.window_height + boundaries.magnit) ) {
                            states.phisical = 'inside';
                            states.locked = true;
                            $window.on('mousewheel.billboard-disable-wheel', function(e) {e.preventDefault()});
                            $HB.not(':animated').animate({
                                scrollTop: boundaries.start
                            }, 500, function () {
                                states.locked = false;
                            });
                        }
                    },
                    'load.billboard-init': function (e) {
                        states.page_loaded = true;
                        methods.getBoundaries();
                    },
                    'resize.billboard-init': function (e) {
                        clearTimeout(resizeTimer);
                        resizeTimer = setTimeout(function(){
                            methods.getBoundaries();
                        }, 200);
                    }
                });
            };

            methods.init();
        });
    };
})(jQuery);


$(function(){
    if ( $$.isMobile ) return;
    var $billboard = $('[js-billboard]');
    $billboard.billboard();
});






// var goTo;
// $(function(){
//     var $billboard = $('[js-billboard]');
//     if ( !$billboard.length ) return;
//     var $HB = $('html, body');
//     var $window = $(window);
//     var $billboard_items = $billboard.find('[js-billboard-item]');
//     var $billboard_bg = $billboard.find('[js-billboard-bg]');
//     var $billboard_nav = $billboard.find('[js-billboard-nav]');
//     var $billboard_nav_bar = $billboard_nav.find('.billboard__nav-bar');
//     var $billboard_nav_number = $billboard_nav_bar.find('.billboard__nav-bar-number');

//     var locked = false;
//     var current_index = 0;
//     var was_index = 0;
//     var items_length = $billboard_items.length;
//     var scrollTop = 0;
//     var allowedTop = 0;
//     var offsetTop = 0;
//     var billboardHeight = 0;
//     var windowHeight = 0;


//     $billboard_nav_bar.css({
//         height: (100/items_length) +'%'
//     });
//     goTo = function (index) {
//         if ( locked || index == current_index ) return;
//         locked = true;
//         was_index = current_index;
//         current_index = index == 'next' ? current_index+1 : index == 'prev' ? current_index-1 : index;
//         if ( was_index > current_index ) {
//             $billboard.addClass('direction-prev');
//         }
//         else {
//             $billboard.removeClass('direction-prev');
//         }
//         current_index = current_index > (items_length-1) ? 0 : current_index < 0 ? items_length-1 : current_index;


//         $billboard_items.eq(was_index).removeClass('is-active').addClass('is-leaving').one({
//             'transitionend webkitTransitionEnd oTransitionEnd': function (e) {
//                 $billboard_items.eq(was_index).removeClass('is-leaving');
//             }
//         });

//         $billboard_bg.css({
//             backgroundColor: $billboard_items.eq(current_index).find('.billboard-slide__bg').css('backgroundColor')
//         });
//         $billboard_items.eq(current_index).removeClass('is-leaving').addClass('is-active');
//         $billboard_nav_bar.css({
//             top: ((current_index*100)/items_length) +'%'
//         });
//         $billboard_nav_number.text( ('0'+ (current_index+1)).slice(-2) );

//         $HB.not(':animated').animate({
//             scrollTop: offsetTop
//         }, 500);

//         setTimeout(function(){
//             locked = false;
//         }, 800);
//     }
//     goTo(1);

//     function bindScroll () {
//         $billboard.off('.billboard-scroll').on({
//             'mousewheel.billboard-scroll': function (e) {
//                 if ( locked ) {
//                     e.preventDefault();
//                     return;
//                 }
//                 if ( e.originalEvent.deltaY > 0 && current_index != items_length-1 ) {
//                     e.preventDefault();
//                     goTo('next');
//                 }
//                 else if ( e.originalEvent.deltaY < 0 && current_index != 0 ) {
//                     e.preventDefault();
//                     goTo('prev');
//                 }
//             }
//         });
//         $window.off('.billboard-scroll').on({
//             'keydown.billboard-scroll': function (e) {
//                 console.log(e.keyCode)
//                 if ( locked ) {
//                     e.preventDefault();
//                     return;
//                 }
//                 if ( (e.keyCode == 40 || e.keyCode == 32) && current_index != items_length-1 ) {
//                     e.preventDefault();
//                     goTo('next');
//                 }
//                 else if ( e.keyCode == 38 && current_index != 0 ) {
//                     e.preventDefault();
//                     goTo('prev');
//                 }
//             }
//         });
//     }
//     function unbindScroll () {
//         $billboard.off('.billboard-scroll');
//         $window.off('.billboard-scroll');
//     }

//     function disableScroll () {
//         $window.off('.disable-scroll').on({
//             'mousewheel.disable-scroll touchmove.disable-scroll keydown.billboard': function (e) {
//                 e.preventDefault();
//             }
//         });
//     }
//     function enableScroll () {
//         $window.off('.disable-scroll');
//     }

//     function updateNumbers () {
//         offsetTop = $billboard.offset().top;
//         billboardHeight = $billboard.height();
//         windowHeight = $window.height();
//         allowedTop = billboardHeight - windowHeight;
//     }

//     var magnit_scroll = true;
//     $window.off('.billboard').on({
//         'mousewheel.billboard touchmove.billboard keydown.billboard': function (e) {
//             scrollTop = $window.scrollTop();
//             // console.log(scrollTop >= Math.round(offsetTop), (scrollTop + windowHeight) <= Math.round(offsetTop + billboardHeight))
//             if ( e.keyCode && !(e.keyCode == 38 || e.keyCode == 40) ) {
//                 return;
//             }
//             if (
//                 current_index != 0 || current_index != items_length-1
//                 && ( (scrollTop) >= Math.round(offsetTop) && (scrollTop + windowHeight) <= Math.round(offsetTop + billboardHeight + 50)
//                 || (scrollTop) >= Math.round(offsetTop - 100) && (scrollTop + windowHeight) <= Math.round(offsetTop + billboardHeight) )
//                 // ( current_index != 0 && (scrollTop) >= Math.round(offsetTop) && (scrollTop + windowHeight) <= Math.round(offsetTop + billboardHeight + 50) )
//                 // ||
//                 // ( current_index != items_length-1 && (scrollTop) >= Math.round(offsetTop - 100) && (scrollTop + windowHeight) <= Math.round(offsetTop + billboardHeight) )
//              ) {
//                 console.log(current_index, items_length-1, current_index != items_length-1)
//                 if ( magnit_scroll ) {
//                     e.preventDefault();
//                     magnit_scroll = false;
//                     locked = true;
//                     $HB.not(':animated').animate({
//                         scrollTop: offsetTop + allowedTop
//                     }, 500, function () {
//                         locked = false;
//                     });
//                     bindScroll();
//                     console.log('magnit_scroll')
//                 }
//             }
//             // else if ( current_index != items_length-1 && (scrollTop) >= Math.round(offsetTop - 100) && (scrollTop + windowHeight) <= Math.round(offsetTop + billboardHeight)) {
//             //     if ( magnit_scroll ) {
//             //         e.preventDefault();
//             //         magnit_scroll = false;
//             //         locked = true;
//             //         $HB.not(':animated').animate({
//             //             scrollTop: offsetTop + allowedTop
//             //         }, 500, function () {
//             //             locked = false;
//             //         });
//             //         bindScroll();
//             //         console.log('0000000000')
//             //     }
//             // }
//             else {
//                 unbindScroll();
//                 magnit_scroll = true;
//                 console.log('123123123')
//             }
//             // if ( current_index != items_length-1 && current_index != 0 && (scrollTop) >= Math.round(offsetTop - 150) && (scrollTop + windowHeight) <= Math.round(offsetTop + billboardHeight + 150) ) {
//             //     if ( magnit_scroll ) {
//             //         magnit_scroll = false;
//             //         $window.scrollTop(offsetTop + allowedTop);
//             //     }
//             //     bindScroll();
//             //     console.log('asdasdasd')
//             // }
//             // else {
//             //     // magnit_scroll = true;
//             //     unbindScroll();
//             //     magnit_scroll = true;
//             //     console.log('123123123')
//             // }
//             if ( allowedTop > 0 && scrollTop < Math.round(offsetTop + allowedTop) ) {
//                 // console.log(scrollTop, offsetTop + allowedTop)
//             }
//             else if ( locked || allowedTop > 0 && scrollTop >= Math.round(offsetTop + allowedTop - 1) ) {
//                 // console.log(2)
//                 // $window.scrollTop(offsetTop + allowedTop);
//                 // $window.on('touchmove mousewheel', function (e) {
//                 //     e.preventDefault();
//                 // });
//                 // $window.disablescroll();
//             }
//         },
//         'load.billboard': function (e) {
//             scrollTop = $window.scrollTop();
//             updateNumbers();
//         }
//     });

//     scrollTop = $window.scrollTop();
//     updateNumbers();


// });

